// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__lkmf9","modalFooterButton":"ModalNotes_modalFooterButton__30doJ"};